import React from 'react';
import { withTranslation } from 'react-i18next';
import ReactDOM from 'react-dom';

import pointer from '../Questions/pointer.png';

class ListFiled extends React.Component {

    state = {
        hoverStyle: '',
        style: '',
        text: '',
        answer: "",
        answers: [],
        isTrue: 2,
        Sort: 0,
        CategoryId: 0,
        AnswerId: 0,
        hover: false,
        onEdit: false
    };

    constructor(props) {
        super(props);
        this.audio = new Audio();
    }

    componentDidMount() {
        const Sort = parseInt(ReactDOM.findDOMNode(this).parentNode.getAttribute("Sort"));
        const isTrue = parseInt(ReactDOM.findDOMNode(this).parentNode.getAttribute("isTrue"));
        this.setState({
            Sort,
            isTrue
        });

        if (this.props.answersList) {
            var answer = this.props.answersList.filter(a => a.Sort === Sort && a.Id === this.props.CategoryId)[0];
            if (answer) {
                this.setState({
                    answer: answer.Answer
                });
            }
        }
    }

    playSound = () => {
        const CustomStyle = this.props.CustomStyle;
        if (CustomStyle && CustomStyle.Sound) {
            var hasItem = CustomStyle.Sound.filter(p => p.Id === this.props.CategoryId && p.Sort === (this.state.Sort - 1))[0];
            if (hasItem) {
                if (this.audio && !this.audio.paused) {
                    this.audio.pause();
                }
                if (hasItem.Url) {
                    this.audio = new Audio(hasItem.Url);
                    this.audio.play();
                }
            }
        }
    }

    static getDerivedStateFromProps(props, state) {
        state.answersList = props.answersList;
        state.answers = props.answers;
        state.fills = props.fills;
        state.CategoryId = props.CategoryId;
        return state;
    }

    handleChangeAnswer = (e, Sort) => {
        this.setState({
            answer: e.target.value
        });
        setTimeout(
            () => {
                this.props.handleChangeAnswer(e.target.value, Sort, this.props.CategoryId);
                window.webuiPopover();
            },
            200
        );
    }

    render() {
        const { t } = this.props;

        let answerIsTrue = "";
        if (this.state.isTrue === 1) {
            answerIsTrue = <i title={t('Pages.Lessons.Questions.forms.trueAnswer')} className="mx-1 fad fa-check-circle text-success h6"></i>;
        } else if (this.state.isTrue === 0) {
            answerIsTrue = <i title={t('Pages.Lessons.Questions.forms.falseAnswer')} className="mx-1 fas fa-exclamation-triangle text-danger h6"></i>;
        }

        let sound = "", Placeholder = "", width = 250, AnswerClass = "dark";
        if (this.props.CustomStyle) {
            const CustomStyle = this.props.CustomStyle;
            if (CustomStyle.Sound) {
                var hasItem = CustomStyle.Sound.filter(p => p.Id === this.props.CategoryId && p.Sort === (this.state.Sort - 1))[0];
                if (hasItem && hasItem.Url) {
                    sound = <button type="button" className="fillTextButton" onClick={e => this.playSound()}><i className={`fad ${this.props.SoundIconType} m-0 fa-volume text-${this.props.SoundIconClass} h5 cursor-pointer`} title={t('Pages.Lessons.Questions.forms.tools.sounds.listen')} ></i> </button>;
                }
            }
            if (CustomStyle.Answers) {
                var hasItemAnswer = CustomStyle.Answers.filter(p => p.Id === this.props.CategoryId && p.Sort === (this.state.Sort - 1))[0];
                if (hasItemAnswer) {
                    if (hasItemAnswer.Width) {
                        width = hasItemAnswer.Width;
                    }
                    if (hasItemAnswer.AnswerClass) {
                        AnswerClass = hasItemAnswer.AnswerClass;
                    }
                    if (hasItemAnswer.Placeholder) {
                        Placeholder = hasItemAnswer.Placeholder;
                    }
                }
            }
        }

        let currentAnswer = "";
        if (this.state.answer) {
            currentAnswer = parseInt(this.state.answer);
        }

        return (
            <>
                <span className="position-relative ">
                    <select
                        className={`m-1 fill-select-answer ${sound ? 'fillTextInputWithSound' : 'fillTextInput'} text-${AnswerClass}`}
                        id={`ListFiledAnswer-${this.state.CategoryId}-${this.state.Sort}`}
                        title={t('Pages.Lessons.Questions.forms.FillTextAnswer.title')}
                        autoComplete="off"
                        placeholder={Placeholder}
                        value={currentAnswer}
                        onChange={e => this.handleChangeAnswer(e, this.state.Sort)}
                        style={{
                            width: `${width}px`,
                            padding: `0 ${width / 15}px`,
                            cursor: `url('${pointer}'),auto`
                        }}  >
                        <option disabled value="">{Placeholder}</option>
                        {
                            this.state.answers.filter(p => this.state.fills.some(f => f.Sort === this.state.Sort && f.CategoryId === this.state.CategoryId && f.AnswerId === p.Id)).sort((a, b) => a.Sort - b.Sort).map(answer => {
                                return <option key={answer.Id} value={answer.Id} >{answer.Name}</option>;
                            })
                        }
                    </select>
                    {sound}
                </span>
                {answerIsTrue}
            </>
        );
    }
}
export default withTranslation('common')(ListFiled);